var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFormatWebUrl = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13478_7544)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5996 0.0117188C25.1583 0.327056 32 7.36421 32 16C32 24.6358 25.1583 31.6719 16.5996 31.9873V32H15.4004V31.9873C6.84168 31.6719 0 24.6358 0 16C0 7.36421 6.84166 0.327056 15.4004 0.0117188V0H16.5996V0.0117188ZM15.4004 22.6113C13.8401 22.6674 12.3356 22.9409 10.916 23.4033C11.9179 26.1199 13.4554 28.5769 15.4004 30.6475V22.6113ZM16.5996 30.6475C18.5446 28.5769 20.0811 26.1198 21.083 23.4033C19.6637 22.9411 18.1596 22.6674 16.5996 22.6113V30.6475ZM9.79004 23.8164C8.21811 24.46 6.76864 25.3408 5.48535 26.4141C7.67472 28.6244 10.5557 30.1476 13.7773 30.6328C12.0751 28.6312 10.7161 26.3287 9.79004 23.8164ZM22.209 23.8164C21.2828 26.3288 19.924 28.6311 18.2217 30.6328C21.4435 30.1478 24.3241 28.6244 26.5137 26.4141C25.2303 25.3408 23.781 24.4599 22.209 23.8164ZM4.6748 6.47266C2.50683 9.04709 1.2002 12.3708 1.2002 16C1.2002 19.6294 2.50756 22.9528 4.67578 25.5273C6.08114 24.3449 7.6744 23.3784 9.4043 22.6787C8.75222 20.5677 8.40043 18.3249 8.40039 16C8.40043 13.675 8.75117 11.4313 9.40332 9.32031C7.67366 8.62042 6.08 7.655 4.6748 6.47266ZM27.3242 6.47266C25.9189 7.65497 24.3255 8.62049 22.5957 9.32031C23.2479 11.4314 23.5996 13.6749 23.5996 16C23.5996 18.325 23.2469 20.5677 22.5947 22.6787C24.3247 23.3784 25.9178 24.3449 27.3232 25.5273C29.4917 22.9528 30.7998 19.6296 30.7998 16C30.7998 12.3706 29.4924 9.04715 27.3242 6.47266ZM10.5312 9.73242C9.92513 11.7145 9.59965 13.8194 9.59961 16C9.59965 18.1809 9.92589 20.2854 10.5322 22.2676C12.0726 21.7645 13.7061 21.4679 15.4004 21.4111V10.5879C13.7057 10.5311 12.0719 10.2357 10.5312 9.73242ZM21.4678 9.73242C19.9274 10.2356 18.2939 10.5311 16.5996 10.5879V21.4111C18.2936 21.4679 19.9267 21.7647 21.4668 22.2676C22.0732 20.2853 22.4004 18.181 22.4004 16C22.4004 13.8193 22.0739 11.7146 21.4678 9.73242ZM15.4004 1.34961C13.4548 3.42039 11.918 5.87859 10.916 8.5957C12.3356 9.05811 13.84 9.33164 15.4004 9.3877V1.34961ZM16.5996 9.3877C18.1597 9.33165 19.6637 9.05794 21.083 8.5957C20.081 5.87871 18.5451 3.42031 16.5996 1.34961V9.3877ZM13.7773 1.36621C10.5554 1.85146 7.67383 3.37526 5.48438 5.58594C6.76752 6.65922 8.21742 7.53904 9.78906 8.18262C10.7152 5.67027 12.075 3.36787 13.7773 1.36621ZM18.2217 1.36621C19.9241 3.3679 21.2837 5.6702 22.21 8.18262C23.7817 7.5391 25.2314 6.65919 26.5146 5.58594C24.325 3.37531 21.4438 1.85127 18.2217 1.36621Z",
    fill: "#D3D6D9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_13478_7544)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_13478_7544",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H29C30.6569 14 32 15.3431 32 17V25C32 26.6569 30.6569 28 29 28H3C1.34315 28 0 26.6569 0 25V17Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 17C0 15.3431 1.34315 14 3 14H29C30.6569 14 32 15.3431 32 17V25C32 26.6569 30.6569 28 29 28H3C1.34315 28 0 26.6569 0 25V17Z",
    fill: "#4F2AF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.8 17C-0.8 14.9013 0.901318 13.2 3 13.2H29C31.0987 13.2 32.8 14.9013 32.8 17H31.2C31.2 15.785 30.215 14.8 29 14.8H3C1.78497 14.8 0.8 15.785 0.8 17H-0.8ZM32 28H0H32ZM3 28C0.901318 28 -0.8 26.2987 -0.8 24.2V17C-0.8 14.9013 0.901318 13.2 3 13.2V14.8C1.78497 14.8 0.8 15.785 0.8 17V25C0.8 26.6569 1.78497 28 3 28ZM29 13.2C31.0987 13.2 32.8 14.9013 32.8 17V24.2C32.8 26.2987 31.0987 28 29 28C30.215 28 31.2 26.6569 31.2 25V17C31.2 15.785 30.215 14.8 29 14.8V13.2Z",
    fill: "black",
    fillOpacity: 0.08,
    mask: "url(#path-3-inside-1_13478_7544)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3785 24.2L20.5723 17.8H21.8191L22.9723 22.5032H23.0316L24.2629 17.8H25.3973L26.6316 22.5063H26.6879L27.841 17.8H29.0879L27.2816 24.2H26.1379L24.8566 19.7094H24.8066L23.5223 24.2H22.3785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3424 24.2L11.5361 17.8H12.783L13.9361 22.5032H13.9955L15.2268 17.8H16.3611L17.5955 22.5063H17.6518L18.8049 17.8H20.0518L18.2455 24.2H17.1018L15.8205 19.7094H15.7705L14.4861 24.2H13.3424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.30625 24.2L2.5 17.8H3.74688L4.9 22.5032H4.95938L6.19063 17.8H7.325L8.55938 22.5063H8.61563L9.76875 17.8H11.0156L9.20938 24.2H8.06563L6.78438 19.7094H6.73438L5.45 24.2H4.30625Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_13478_7544",
    x: 0,
    y: 14,
    width: 32,
    height: 17.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_13478_7544"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13478_7544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFormatWebUrl);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FormatWebUrl.76f044bc443db54d29c5f2ea1a299362.svg";